export const validateLink = (value?: string | null) => {
  if (!value) {
    return '';
  }

  const hasProtocol = value.startsWith('http');

  return hasProtocol ? value : `https://${value}`;
};
